import { css } from '@emotion/react';
import React from 'react';
import { Country } from 'react-phone-number-input';

import { colors } from '~src/theme/colors';
import { fontStyles } from '~src/theme/fontStyles';
import { mediaQueries } from '~src/theme/mediaQueries';
import { RadioInputMock } from '~src/ui/radio-input';

import { CountryLogo } from './country-logo';

interface CountryCardProps {
  country: Country;
  countryName: string;
  innerRef: React.RefObject<HTMLDivElement>;
  selected: boolean;
}

export const CountryCard: React.FC<CountryCardProps> = ({
  country,
  countryName,
  innerRef,
  selected,
  ...props
}) => {
  return (
    <div
      aria-label={countryName}
      css={styles.wrapper}
      className="focus-visible-outline"
      ref={innerRef}
      style={{
        cursor: selected ? 'initial' : 'pointer',
      }}
      {...props}
    >
      <RadioInputMock title={countryName} checked={selected} />

      <span aria-hidden="true" css={styles.label}>
        {countryName}
      </span>

      <CountryLogo countryCode={country} height={24} />
    </div>
  );
};

const styles = {
  wrapper: css({
    display: 'grid',
    columnGap: '10px',
    gridTemplateColumns: '20px auto 24px',
    borderTop: `1px solid ${colors.neutral90}`,
    padding: '18px 0px',
    height: '61px',
  }),
  label: {
    ...fontStyles.px16_20,
    [mediaQueries.S]: {
      ...fontStyles.px14_20,
    },
  },
};
